import { createAction } from './core';
// PUBLIC API
export const seedConfig = createAction('operations/seed-config', ['AppConfig']);
// PUBLIC API
export const backwardCompatibility = createAction('operations/backward-compatibility', ['User', 'MiqCollection']);
// PUBLIC API
export const updateCurrentUser = createAction('operations/update-current-user', ['User']);
// PUBLIC API
export const updateUserById = createAction('operations/update-user-by-id', ['User']);
// PUBLIC API
export const deleteUserByIdDev = createAction('operations/delete-user-by-id-dev', ['User']);
// PUBLIC API
export const resetUserData = createAction('operations/reset-user-data', ['User', 'OnboardingTask', 'MiqCollection']);
// PUBLIC API
export const initializeUserData = createAction('operations/initialize-user-data', ['User', 'OnboardingTask']);
// PUBLIC API
export const addSystemLog = createAction('operations/add-system-log', ['Logs']);
// PUBLIC API
export const createOnboardingTask = createAction('operations/create-onboarding-task', ['OnboardingTask']);
// PUBLIC API
export const updateOnboardingTask = createAction('operations/update-onboarding-task', ['OnboardingTask']);
// PUBLIC API
export const copyCollectionToAdmin = createAction('operations/copy-collection-to-admin', ['User', 'MiqCollection', 'EnrichmentJob']);
// PUBLIC API
export const deleteAdminCollection = createAction('operations/delete-admin-collection', ['User', 'MiqCollection', 'EnrichmentJob']);
// PUBLIC API
export const createMiqCollection = createAction('operations/create-miq-collection', ['MiqCollection']);
// PUBLIC API
export const updateMiqCollection = createAction('operations/update-miq-collection', ['MiqCollection']);
// PUBLIC API
export const deleteMiqCollection = createAction('operations/delete-miq-collection', ['MiqCollection']);
// PUBLIC API
export const createPlan = createAction('operations/create-plan', ['Plan']);
// PUBLIC API
export const deletePlan = createAction('operations/delete-plan', ['Plan']);
// PUBLIC API
export const createUserSubscription = createAction('operations/create-user-subscription', ['UserSubscription', 'Plan', 'CreditBalance', 'SubscriptionStatusHistory', 'CreditTransaction']);
// PUBLIC API
export const updateCreditBalance = createAction('operations/update-credit-balance', ['CreditBalance', 'CreditTransaction']);
// PUBLIC API
export const logTransaction = createAction('operations/log-transaction', ['CreditTransaction']);
// PUBLIC API
export const resetCredits = createAction('operations/reset-credits', ['CreditBalance', 'Plan']);
// PUBLIC API
export const cancelSubscription = createAction('operations/cancel-subscription', ['UserSubscription', 'SubscriptionStatusHistory']);
// PUBLIC API
export const getPricingUrl = createAction('operations/get-pricing-url', ['User']);
// PUBLIC API
export const getShopifyUrl = createAction('operations/get-shopify-url', []);
// PUBLIC API
export const createEnrichment = createAction('operations/create-enrichment', ['EnrichmentValues', 'MarketFactsRadarMultiplier']);
// PUBLIC API
export const updateEnrichment = createAction('operations/update-enrichment', ['EnrichmentValues', 'MarketFactsRadarMultiplier']);
// PUBLIC API
export const deleteEnrichment = createAction('operations/delete-enrichment', ['EnrichmentValues', 'MarketFactsRadarMultiplier']);
// PUBLIC API
export const createEnrichmentTask = createAction('operations/create-enrichment-task', ['EnrichmentJob']);
// PUBLIC API
export const updateEnrichmentTask = createAction('operations/update-enrichment-task', ['EnrichmentJob']);
// PUBLIC API
export const updateEnrichmentTask2 = createAction('operations/update-enrichment-task2', ['EnrichmentJob']);
// PUBLIC API
export const deleteEnrichmentTask = createAction('operations/delete-enrichment-task', ['EnrichmentJob']);
// PUBLIC API
export const startExportToShopify = createAction('operations/start-export-to-shopify', ['EnrichmentJob']);
//# sourceMappingURL=index.js.map